import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { Pqr } from '../../class/pqr';

@Injectable()
export class PqrService extends WebService {

    public getPqr (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('attended_by,worked_by,verified_by,venue,company,report_user,department'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/pqrs?${params}`, options);
    }

    public newPqr(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/pqrs`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updatePqr(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/pqrs/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deletePqr(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/pqrs/${id}`, { headers: this.headers } );
    }

    public infoPqr(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/pqrs?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/pqr/pqr.service.ts